<p data-test="wip-text">Work in progess!</p>
<p data-test="dynamic-text">
  Functionality: <strong>{{ textContent }} coming soon</strong>
</p>
